module.exports = __webpack_public_path__ + "static/media/le.9374ecdb.JPG";